export default "__VITE_ASSET__BN0ilGvv__"